import { render, staticRenderFns } from "./PortalGestor.vue?vue&type=template&id=166c0273&scoped=true&"
import script from "./PortalGestor.vue?vue&type=script&lang=js&"
export * from "./PortalGestor.vue?vue&type=script&lang=js&"
import style0 from "./PortalGestor.vue?vue&type=style&index=0&id=166c0273&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166c0273",
  null
  
)

export default component.exports